import { useState } from "react";

import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";

import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";

const AddAttributePopup = new Popup({
	title: () => getLocaleString("addattribute"),
	distinct: true,
	render: function() {
		const features:Feature<Geometry>[] = this.get("features");
		const onSaved:Function = this.get("onSaved");
			
		const [name, setName] = useState<string>("");
		const [value, setValue] = useState<string>("");
		
		const addAttribute = () => {
			let used:boolean = false;
			
			features.forEach((feature:Feature<Geometry>) => {
				if(feature.get(name) !== undefined)
					used = true;
			});
			
			if(used)
				return _ui.showError(getLocaleString("attributeused"));
			
			features.forEach((feature:Feature<Geometry>) => {
				feature.set(name, value);
			});
			
			_ui.closePopupOf(this);
			
			onSaved?.();
		}
		
		return (
			<div className="popup-confirm">
				
				<input 
					type="text" 
					placeholder={getLocaleString("attributename")}
					value={name} 
					maxLength={24}
					onChange={(e:any) => setName(e.target.value)}
				/>
				
				<br />
				<br />
				
				<input 
					type="text" 
					placeholder={getLocaleString("attributevalue")}
					value={value} 
					onChange={(e:any) => setValue(e.target.value)}
				/>
				
				<br />
				<br />
				
				<div className="confirm-buttons">
					<button onClick={addAttribute}>
						{getLocaleString("save")}
					</button>
					<button onClick={() => _ui.closePopupOf(this)}>
						{getLocaleString("cancel")}
					</button>
				</div>
			</div>
		)
	}
});

export default AddAttributePopup;